import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "credit-card-icon",
  role: "img",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M6.25 13C6.25 12.5858 6.58579 12.25 7 12.25H9.57C9.98421 12.25 10.32 12.5858 10.32 13C10.32 13.4142 9.98421 13.75 9.57 13.75H7C6.58579 13.75 6.25 13.4142 6.25 13Z" }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M2.25 8C2.25 5.92879 3.92879 4.25 6 4.25H18C20.0712 4.25 21.75 5.92879 21.75 8V16C21.75 18.0712 20.0712 19.75 18 19.75H6C3.92879 19.75 2.25 18.0712 2.25 16V8ZM3.75 8C3.75 6.75721 4.75721 5.75 6 5.75H18C19.2428 5.75 20.25 6.75721 20.25 8V8.25H3.75V8ZM20.25 9.75V16C20.25 17.2428 19.2428 18.25 18 18.25H6C4.75721 18.25 3.75 17.2428 3.75 16V9.75H20.25Z"
    }, null, -1)
  ])))
}
export default { render: render }